import React from 'react';

const WhatYouLearn = () => (
  <div className="container mx-auto text-center px-4 sm:px-6 lg:px-8 bg-white py-10 rounded-lg shadow-lg">
    <h2 className="text-3xl sm:text-4xl font-bold text-blue-600 mb-6">What You'll Learn</h2>
    <ul className="mt-6 space-y-4 text-left max-w-3xl mx-auto">
      <li className="flex items-start">
        <span className="text-green-500 font-bold mr-2">✔</span>
        Modern frontend frameworks (React, Next.js)
      </li>
      <li className="flex items-start">
        <span className="text-green-500 font-bold mr-2">✔</span>
        Backend development with Node.js and databases
      </li>
      <li className="flex items-start">
        <span className="text-green-500 font-bold mr-2">✔</span>
        Cloud deployment and DevOps practices
      </li>
      <li className="flex items-start">
        <span className="text-green-500 font-bold mr-2">✔</span>
        System design and architecture principles
      </li>
    </ul>
  </div>
);

export default WhatYouLearn;
